<template>
  <div class="agree" :data-policy-version="policy ? policy.version_id : null">
    <p v-if="loading" role="status">隐私政策加载中…</p>
    <div v-else-if="!policy" role="alert">
      <p>隐私政策加载失败，请重试。</p>
      <button class="retry-button" type="button" @click="loadPolicy">重新加载</button>
    </div>
    <article v-else>
      <h1 class="policy-title">{{ policy.title }}</h1>
      <p>生效及更新日期：{{ policyDate }}</p>
      <div class="policy-content" v-html="policy.content_html"/>
    </article>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'PrivacyPolicy',
  props: {
    platform: {
      type: String,
      required: true,
      validator: value => ['general', 'huawei', 'vivo'].includes(value)
    }
  },
  data () {
    return {
      loading: true,
      policy: null,
      requestId: 0
    }
  },
  computed: {
    policyDate () {
      return this.policy.policy_date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1年$2月$3日')
    }
  },
  watch: {
    platform: 'loadPolicy'
  },
  created () {
    this.loadPolicy()
  },
  beforeDestroy () {
    this.requestId++
  },
  methods: {
    async loadPolicy () {
      const requestId = ++this.requestId
      const platform = this.platform
      this.loading = true
      this.policy = null
      document.title = '默往隐私政策'
      try {
        const response = await request({
          url: '/public/get_privacy_policy',
          method: 'get',
          params: { policy_platform: platform }
        })
        if (requestId !== this.requestId) return
        const policy = response && response.data
        if (response.code !== 200 || !policy || policy.policy_platform !== platform ||
          typeof policy.version_id !== 'string' || !/^\d+$/.test(policy.version_id) ||
          typeof policy.title !== 'string' || !policy.title.trim() ||
          typeof policy.policy_date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(policy.policy_date) ||
          typeof policy.content_html !== 'string' || !policy.content_html.trim()) {
          throw new Error('Invalid privacy policy response')
        }
        this.policy = policy
        document.title = policy.title
      } catch (error) {
        if (requestId === this.requestId) this.policy = null
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agree {
  line-height: 1.5;
  padding: 10px;
  font-size: 15px;
  overflow-wrap: break-word;
  word-break: break-word;
}

p {
  font-size: 15px;
}

.policy-title {
  margin-bottom: 10px;
  font-size: 18px;
}

.retry-button {
  margin-top: 10px;
  padding: 6px 12px;
  font-size: 15px;
  cursor: pointer;
}

.policy-content {
  ::v-deep p {
    font-size: 15px;
  }

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5,
  ::v-deep h6 {
    margin: 10px 0;
    font-size: 16px;
  }

  ::v-deep ul,
  ::v-deep ol {
    padding-left: 1.5em;
  }

  ::v-deep ul {
    list-style-type: disc;
  }

  ::v-deep ol {
    list-style-type: decimal;
  }

  ::v-deep table {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
  }

  ::v-deep th,
  ::v-deep td {
    border: 1px solid #ddd;
    padding: 6px;
    vertical-align: top;
    overflow-wrap: break-word;
  }

  ::v-deep pre {
    white-space: pre-wrap;
  }
}
</style>
